export const SHOW_MODAL = 'showModal'
export const HIDE_MODAL = 'hideModal'
export const SHOW_SLIDE_MENU = 'showSlideMenu'
export const STORE_INVITE_STATS = 'storeInviteStats'
export const FETCH_REVIEW_ANALYTICS = 'getReviewAnalytics'
export const FETCH_REVIEW_ANALYTICS_STATS = 'getReviewAnalyticsStats'
export const FETCH_REVIEW_ANALYTICS_GRAPH = 'getReviewAnalyticsGraph'
export const FETCH_REVIEW_ANALYTICS_USAGE = 'getReviewAnalyticsUsage'
export const FETCH_REVIEW_INVITE_ANALYTICS_STATS = 'getReviewInviteAnalyticsStats'
export const FETCH_REVIEW_INVITE_ANALYTICS_GRAPHS = 'getReviewInviteAnalyticsGraphs'
export const FETCH_REVIEW_INVITE_CONVERSION_ANALYTICS_GRAPHS = 'getReviewInviteConversionAnalyticsGraphs'
export const FETCH_INDUSTRIES = 'fetchIndustries'



// WEBPACK FOOTER //
// ./src/store/action.types.js